exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-projects-tags-filter {\n  min-width: 235px;\n  max-width: 300px;\n}\n.test-projects-tags-option {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.test-projects-tags-option .tag-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  margin-right: 8px;\n}\n.test-projects-tags-option .tag-count {\n  font-size: 12px;\n  color: #888;\n  flex-shrink: 0;\n}\n.test-projects-tags-option .no-tags-text {\n  font-style: italic;\n  color: #666;\n}\n", ""]);

// exports
